<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">

        <div class="mt-2">
          <label class="txt-right required">Tình trạng thiết bị</label>
          <Dropdown v-model="status" :options="status_types" optionLabel="label" placeholder="Chọn tình trạng thiết bị"/>
          <input class="input_tmp_validator" id="status" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Loại thiết bị</label>
          <InputText
            v-model="name"
            id="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
          />
        </div>
        
        <div class="mt-3">
          <label class="txt-right required">Mã thiết bị</label>
          <InputText
            v-model="code"
            id="code"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập mã thiết bị"
            :disabled="mode=='edit'"
            @input="formatCode"
          />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Trang trại</label>
          <Dropdown 
            v-model="farm"
            :options="listFarm"
            optionLabel="name"
            placeholder="Chọn trang trại"/>
          <input class="input_tmp_validator" id="farm" />
        </div>

        <div class="mt-3">
          <label class="txt-right">Unit</label>
          <Dropdown
            v-model="unit"
            :options="ListUnit"
            optionLabel="name"
            placeholder="Chọn unit"/>  
        </div>

        <div class="mt-2">
          <label>&nbsp;</label>
        </div>

        <div class="mt-2">
          <div style="font-weight: bolder; font-size: large;">THÔNG TIN CHUNG</div>
        </div>

        <div class="mt-2">
          <label class="txt-right">Kiểu dáng</label>
          <InputText
            v-model="style"
            id="style"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
        </div>

        <div class="mt-3">
          <label class="txt-right">Kích thước</label>
          <InputText
            v-model="size"
            id="size"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
        </div>

        <div class="mt-2">
          <label class="txt-right required">Chu kì bảo dưỡng</label>
          <div class="p-inputgroup">
            <InputText
              v-model="storage_cycle"
              id="storage_cycle"
              type="Number"
              class="text-box input-text-box"
              placeholder="Nhập"
              @input="allowOnlyNumbers('storage_cycle')"
            />
            <span class="p-inputgroup-addon">
              ngày
            </span>
          </div>
        </div>

        <div class="mt-3">
          <label class="txt-right">Năng suất sử dụng</label>
          <InputText
            v-model="usage_productivity"
            id="usage_productivity"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
        </div>

        <div class="mt-3" v-if="mode == 'edit'">
          <label class="txt-right">Ngày tạo</label>
          <InputText
            v-model="created_at"
            id="created_at"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="true"
          />
        </div>

        <div class="mt-3" v-if="mode == 'edit'">
          <label class="txt-right">Ngày cập nhật</label>
          <InputText
            v-model="updated_at"
            id="updated_at"
            type="text"
            class="text-box input-text-box"
            placeholder="Chưa cập nhật"
            :disabled="true"
          />
        </div>

        <div class="mt-3 d-flex align-items-center p-0">
          <Checkbox id="active" v-model="active" :binary="true" />
          <label for="active" class="m-0 ml-2">Hiển thị</label>
        </div>
        
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      status: null,
      status_types: [
        { value: 0, label: 'Không hoạt động' },
        { value: 1, label: 'Hoạt động' }
      ],
      name: "",
      code: "",
      farm: null,
      unit: null,
      style: null,
      size: 0,
      storage_cycle: "",
      usage_productivity: null,
      created_at: "",
      active: true,
      listFarm: [],
      ListUnit: [],
      updated_at: "",
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    await this.getListFarm();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        this.status = this.status_types.find((item) => item.value === this.model.status);
        this.name = this.model.name;
        this.code = this.model.code;
        this.farm = this.listFarm.find((item) => item.id === this.model.farm_has_equipments[0].farm.id);
        await this.getListUnit();
        if (this.model.equipment_has_units.length > 0){
          this.unit = this.ListUnit.find((item) => item.id === this.model.equipment_has_units[0].has_unit.id);
        }
        this.style = this.model.style;
        this.size = this.model.size;
        this.storage_cycle = this.model.storage_cycle;
        this.usage_productivity = this.model.usage_productivity;
        this.created_at = this.model.created_at;
        this.active = this.model.active;
        this.updated_at = this.model.updated_at;
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  watch: {
    async "farm"() {
      if (this.farm) {
        this.ListUnit = [];
        await this.getListUnit();
      }
    },
  },
  methods: {
    backToList() {
      this.$emit("back");
    },

    allowOnlyNumbers(field) {
      // Only allow positive integers
      const value = this[field];
      const numericValue = value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters

      // Ensure the value does not start with '0' unless it's the only character
      if (numericValue.length > 1 && numericValue.startsWith('0')) {
        this[field] = numericValue.substring(1);
      } else {
        this[field] = numericValue;
      }
    },

    formatCode() {
      // Format code to allow only letters and convert to uppercase
      this.code = this.code.replace(/[^a-zA-Z]/g, '').toUpperCase();
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where ={
        active: {_eq: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: {name: "asc"}
        }
      })
      var listData = resData.data["farm"];
      this.listFarm = listData;
    },

    async getListUnit() {
      var gqLQueryList = DataServices.getList("cs_unit", { "fields": "id, name" });
      var where = {
        active: { _eq: true },
        farm_id: { _eq: this.farm.id },
        deleted: { _eq: false }
      };
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" }
        }
      });
      var listData = resData.data["cs_unit"];
      this.ListUnit = listData.map(unit => {
        let [unit_name] = unit.name.split(" - ");
        return { ...unit, name: unit_name };
      });
    },

    async existCode() {
      var gqLQueryList = DataServices.getList("equipment", {"fields": "id"});
      var where = {
          code: {_eq: this.code},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
        },
      });
      var listData = resData.data["equipment"];
      if (listData.length > 0) {
        return true;
      }
      return false;
    },

    async validateData() {
      this.validationErrors = {};

      let status_add = document.getElementById("status");
      if (this.$commonFuction.isEmptyObject(this.status)) {
        status_add.setCustomValidity("Tình trạng thiết bị không được để trống!");
      } else {
        status_add.setCustomValidity("");
      }

      let name_add = document.getElementById("name");
      if (this.$commonFuction.isEmptyObject(this.name)) {
        name_add.setCustomValidity("Loại thiết bị không được để trống!");
      } else {
        name_add.setCustomValidity("");
      }

      let code_add = document.getElementById("code");
      if (this.$commonFuction.isEmptyObject(this.code)) {
        code_add.setCustomValidity("Mã thiết bị không được để trống!");
      } else if (await this.existCode()) {
        code_add.setCustomValidity("Mã thiết bị đã tồn tại!");
      } else {
        code_add.setCustomValidity("");
      }

      let farm_add = document.getElementById("farm");
      if (this.$commonFuction.isEmptyObject(this.farm)) {
        farm_add.setCustomValidity("Trang trại không được để trống!");
      } else {
        farm_add.setCustomValidity("");
      }

      let storage_cycle_add = document.getElementById("storage_cycle");
      if (this.$commonFuction.isEmptyObject(this.storage_cycle)) {
        storage_cycle_add.setCustomValidity("Chu kì bảo dưỡng không được để trống!");
      } else {
        storage_cycle_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      let unitID = null;
      if (this.unit){
        unitID = this.unit.id;
      }
      var params = {
        status: this.status.value,
        name: this.name,
        code: this.code,
        farm_id: this.farm.id,
        unit_id: unitID,
        style: this.style,
        size: this.size,
        storage_cycle: this.storage_cycle,
        usage_productivity: this.usage_productivity,
        active: this.active,
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>
